<template>
  <div class="offer-list-container">
    <v-card>
      <div class="offer-list-card-header">
        <h1 class="title mb-8">Listagem das ofertas</h1>
      </div>
      <div class="offer-list-config">
        <div class="mobile-frame-section">
          <mobile-frame height="770px">
            <template v-slot:mobile-content>
              <offer-list />
            </template>
          </mobile-frame>
        </div>
        <div class="config-list-section">
          <div class="offer-list-description">
            <span
              >A tela de listagem das ofertas vai ser exibida ao clicar no destaque. Nela vai estar listada todas as ofertas que fazem parte da sua
              campanha.</span
            >
          </div>
          <div v-if="isExpandedModel" class="config-offer-list">
            <display-title class="mt-10 mb-5" :error="displayTitleError" :error-message="displayTitleErrorMessage" :disabled="finishedHighlight" />
          </div>
          <div v-else class="config-list-default">
            <div class="header-image-toggle-section my-4">
              <mf-toggle v-model="useHeaderImage" class="pa-0" hide-details label="Imagem de cabeçalho na listagem" :disabled="finishedHighlight" />
            </div>
            <mf-image-cropper
              v-if="useHeaderImage"
              :mb-size-limit="1"
              :disabled="!useHeaderImage || finishedHighlight"
              :upload-image="modifyImg"
              :error-message="''"
              :url="imageURL"
              :width="355"
              :height="220"
              show-hint
              @remove-image="deleteFile"
              @snackbar="showSnackbar"
            />
          </div>
          <div class="offer-tag">
            <config-tag />
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import { highlightOffer } from '../../../../mixins/highlight-offer'
import { mapGetters } from 'vuex'

export default {
  name: 'ConfigOffersList',
  components: {
    MobileFrame: () => import('../MobileFrame.vue'),
    OfferList: () => import('./OfferList.vue'),
    ConfigTag: () => import('./ConfigTag.vue'),
    DisplayTitle: () => import('./DisplayTitle.vue'),
  },
  mixins: [highlightOffer],
  props: {
    displayTitleError: {
      type: Boolean,
      default: false,
    },
    displayTitleErrorMessage: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    useHeaderImage: false,
    imageUploaded: false,
    displayTitle: '',
  }),
  computed: {
    ...mapGetters(['isExpandedModel', 'isDefaultModel']),
    finishedHighlight() {
      return this.highlightStatus === 'FINISHED'
    },
    imageURL: {
      get() {
        return this.highlightBannerImage
      },
      set(value) {
        this.setHighlightKeyValue({ payload: value, key: 'bannerImage' })
      },
    },
  },
  watch: {
    useHeaderImage: {
      handler(newValue) {
        this.setUseHeaderImage(newValue)
        if (!newValue) {
          this.imageURL = ''
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.highlightBannerImage.length > 0) {
      this.useHeaderImage = true
    }
  },
  methods: {
    showSnackbar(snackbar) {
      this.$snackbar(snackbar)
    },
    deleteFile() {
      if (!this.finishedHighlight) {
        this.imageURL = ''
      }
    },
    async modifyImg({ base64, filename }) {
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: {
            filename,
            base64,
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.imageUploaded = true
          this.imageURL = url
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.offer-list-container {
  .v-card {
    padding: 24px 30px 0 30px;
    .offer-list-config {
      display: flex;
      flex-direction: row;
      gap: 145px;
      .mobile-frame-section {
        padding-left: 40px;
      }
      .config-list-section {
        width: auto;
        display: flex;
        flex-direction: column;
        .offer-list-description {
          color: #656565;
          font-size: 14px;
          font-weight: 700;
          line-height: 20px;
        }
        .config-list-default {
          .header-image-toggle-section {
            ::v-deep .v-label {
              color: $cinza-d10;
              font-family: Lato;
              font-size: 18px !important;
              font-style: normal;
              font-weight: 700 !important;
              line-height: 120%; /* 21.6px */
            }
          }
        }
      }
    }
  }
}
</style>
